import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from './store'
import { useEffect, useState } from "react";
import { showAndHideSpinner } from "app/reducers/spinnerSlice";

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppDispatch = () => useDispatch<AppDispatch>()
export function useJSScript(src: string, doAsync?: boolean) {
  const [isLoad, setIsLoad] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const handleLoad = () => setIsLoad(true);
    const handleError = (error: any) => setError(error);

    let script: HTMLScriptElement | null = document.querySelector(`script[src="${src}"]`);
    if(!script) {
      script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;
      script.async = doAsync??true;

      script.addEventListener('load', handleLoad);
      script.addEventListener('error', handleError);
      document.head.appendChild(script);
    } else {
      setIsLoad(true);
    }

    return () => {
      let script: HTMLScriptElement | null = document.querySelector(`script[src="${src}"]`);
      if(script) {
        script.removeEventListener('load', handleLoad);
        script.removeEventListener('error', handleError);
        document.head.removeChild(script);
      }
    }
  }, [src]);

  return [isLoad, error];
}

export function useOzJsScript(elementId?: string) {
  const dispatch = useAppDispatch();
  const [isLoad, error] = useJSScript('/ozreport/ozhviewer/OZJSViewer.js', false);

  const [innerHtml, setInnerHtml] = useState<string|undefined>();

  useEffect(() => {
    const viewerDomId: string = elementId ?? "OZViewer";
    const scriptId: string = viewerDomId + 'OzCustomViewerJs';

    if (isLoad && !error && innerHtml) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'text/javascript';

      script.innerHTML = `
        function SetOZParamters_${viewerDomId}() {
          let oz;
          oz = document.getElementById("${viewerDomId}");
          oz.sendToActionScript("viewer.viewmode", "fittoframe");
          oz.sendToActionScript("viewer.fontdpi", "auto");
          oz.sendToActionScript("viewer.pagenavigate_by_scroll", "true");
          
          oz.sendToActionScript("toolbar.addmemo", "false");
          oz.sendToActionScript("toolbar.find", "false");
          oz.sendToActionScript("toolbar.etc", "false");
          oz.sendToActionScript("toolbar.useseparator", "false");
          
          oz.sendToActionScript("export.applyformat","pdf");
          oz.sendToActionScript("export.format","pdf");
          oz.sendToActionScript("pdf.fontembedding","true"); // PDF 폰트포함 (글꼴 깨지는것 방지)
          oz.sendToActionScript("pdf.fontembedding_subset","true"); // 폰트의 서브셋을 저장할지 여부
          
          oz.sendToActionScript("connection.servlet", "${process.env.REACT_APP_URL_REPORT}/server");
          
          ${innerHtml}
          
          
          return true;
        }
        
        var opt = [];
        opt["print_exportfrom"] = "server";
        opt["save_exportfrom"] = {"pdf" : "server"};
        start_ozjs("${viewerDomId}", "${process.env.REACT_APP_URL_REPORT}/ozhviewer/", opt);
      `;

      document.body.appendChild(script);
      dispatch(showAndHideSpinner(false));

      return () => {
        document.body.removeChild(script);
      }
    } else {
      dispatch(showAndHideSpinner(true));
    }

    return () => {
      let customScript: HTMLScriptElement | null = document.querySelector(`script[id=${scriptId}]`);
      if (customScript) {
        document.body.removeChild(customScript);
      }
    }
  }, [isLoad, error, innerHtml]);

  return setInnerHtml;
}